<template>
    <scroll-page :pull-reload="false">

    <list-talks :group_id="group_id"/>

    </scroll-page>
  
</template>

<script>

import ScrollPage from '../components/ScrollPage.vue';
import ListTalks from '../components/talks/ListTalks.vue';

export default {
  name: 'group-list-talks-page',
  data:function(){
    return {
      talks:[],
      group_id:this.$route.params.id,
    }
  },
  methods:{
    getTalks(){
     
    
   // this.loading=true;

      var payload={
        group_id:this.group_id,
      }
    this.$store.dispatch('get_teacher_talks',payload).then(result=>{
      if(result.data.length==0){
        return;
      }else{
       
       this.talks=result.data;
       
      }

    })
    },
  },
  computed:{
  },
  components:{
    ScrollPage,
    ListTalks,
  },
  created(){
  },
  mounted(){
    // lets get the talks..
  this.getTalks();
  },
  beforeDestroy(){
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
